module.exports = __webpack_public_path__ + "static/media/male.90ce3d45.svg";